import SingleMaterialCard from '../SingleMaterialCard/SingleMaterialCard';
import './QuestionBankList.scss';
import SinglePodcastCard from '../SinglePodcast/SinglePodcastCard';
import { useEffect, useRef, useState } from 'react';
import { materialsData } from '../../utils/interface';
import { useAppSelector } from '../../redux/app/hooks';
import { checkFileStatusInDatabase } from '../../database';
import { MYLIBRARY_TEXTS } from '../../utils/constants';

interface QuestionBankListProps {
  type?: string;
  isQuestionBank?: boolean;
  subject?: string;
  subCategory?: string;
  questionBankData: materialsData[] | undefined;
  handleOpenFile: (pdfData: materialsData) => void;
  handleMaterialActions: (data:materialsData,action:string) => void;
  setRefetch: any;
}
const QuestionBankList: React.FC<QuestionBankListProps> = ({ type, questionBankData, handleOpenFile, handleMaterialActions, isQuestionBank, subject, subCategory,setRefetch }) => {
  const DescriptionRef  = useRef<(HTMLSpanElement | null)[]>([]);
  const [isDescOverflow,setIsDescOverflow] = useState<boolean[]>([]);
  const [fileExists, setFileExists] = useState<{ [key: string]: boolean| undefined }>({});
  const profile = useAppSelector((state) => state.auth.adminProfile);

    //To check description is overflow
    const checkOverflowDescription = (index:number) => {
      if(DescriptionRef?.current && DescriptionRef?.current[index]){
        const overflow = (DescriptionRef.current[index]!.scrollHeight) > DescriptionRef.current[index]!.clientHeight;
        setIsDescOverflow((prev:any) => {
                    const newOverflow = [...prev];
                    newOverflow[index] = overflow;
                    return newOverflow;
        });
      }
    }

  const handleResize = () => {
    questionBankData?.forEach((_, index) => {
      checkOverflowDescription(index);
    });
  }

    //To check overflow in resize 
    useEffect(() => {
      handleResize();
      window.addEventListener('resize',handleResize);

      return () => {
          window.addEventListener('resize',handleResize);
      };
}, []);

// Function to check if the file exists
const checkFileExistence = async (material: materialsData) => {
  if(window.electron && window.electron.isElectron()){
  try{
  const response = await window.electron.checkFileStatus(
      material.fileId,
      profile?.getCurrentUser?.nodes[0]?.uId,
      subCategory
  );

  console.log('response======>', response);
  // Check if response is defined and successful
  if (response && response.success) {
      return response.exists; // Return the exists value (true/false)
  }

  console.error('Failed to check file existence:', response);
  return false; // Default return value if the file existence check fails
}catch(err){
  console.error('Error checking file existence:', err);
  return false; // Return false if there's an error during the check
}
}else{
  console.warn("Platform not supported");
}
};

// Check the existence of each file and update the state
useEffect(() => {
  const checkFiles = async () => {
      const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
      if (questionBankData && questionBankData.length > 0) {
          for (const audio of questionBankData) {
              const exists = await checkFileExistence(audio);
              console.log('Inside the exists of checkFiles', exists);
              updatedFileExists[audio.filepath] = exists; // Use the value from exists
          }
          setFileExists(updatedFileExists);
      }
  };
  checkFiles();
}, [questionBankData]);

  const checkFileExists = async (material: materialsData) => {
    if (window.cordova) {
        try {
            const response = await checkFileStatusInDatabase(
                material.fileId,
                profile?.getCurrentUser?.nodes[0]?.uId,
                subCategory
            );

            console.log('File existence response:', response);
            if (response && response.success) {
                console.log(response,'=======file existance response');
                return response.exists;
            }

            console.error('Failed to check file existence:', response);
            return false;
        } catch (err) {
            console.error('Error checking file existence:', err);
            return false;
        }
    } else {
        console.warn("Cordova is not available");
        return false;
    }
  };

  useEffect(() => {
    const checkFiles = async () => {
        const updatedFileExists: Record<string, boolean| undefined> = {}; // Define the type here
        if (questionBankData && questionBankData.length > 0) {
            for (const audio of questionBankData) {
                const exists = await checkFileExists(audio);
                console.log('Inside the exists of checkFiles', exists);
                updatedFileExists[audio.filepath] = exists; // Use the value from exists
            }
            setFileExists(updatedFileExists);
        }
    };
    checkFiles();
  }, [questionBankData]);

  return (
    <div className='qsBankListMainContainer'>
      <div className={questionBankData && questionBankData?.length > 0 ? 'qsBankListContainer' : 'noData'}>
        {
          questionBankData && questionBankData?.length > 0 ?
            (
              questionBankData?.map((material: materialsData, index: number) => (
                type === MYLIBRARY_TEXTS?.PODCAST_TEXT ? (
                  <SinglePodcastCard checkOverflowDescription={checkOverflowDescription} DescriptionRef={DescriptionRef} isDescOverflow={isDescOverflow} setIsDescOverflow={setIsDescOverflow} keyValue={`${material?.filepath}-${index}`} index={index} material={material} handleOpenFile={handleOpenFile} handleMaterialActions={handleMaterialActions} subject={subject} subCategory={subCategory} fileExists={fileExists[material?.filepath]} reload={setRefetch(true)}/>
                ):
                (
                  <SingleMaterialCard material={material?.filename} keyValue={`${material?.filepath}-${index}`} materialData={material} handleOpenFile={handleOpenFile} handleMaterialActions={handleMaterialActions} isQuestionBank={isQuestionBank} />
                )
              ))
            )
            : <div className='noDataFoundStyle'>No data found</div>
        }
      </div>
    </div>
  )
}

export default QuestionBankList;
